import React from 'react'
import {
  Anchor,
  Button,
  Div,
  Flex,
  List,
  ListItem,
  SelectableCard,
  Spacer,
  Text,
  UserCard,
} from '@sendoutcards/quantum-design-ui'
import { useEffect, useQueries, useState } from 'src/hooks'
import { getPossibleSponsors, SponsorFragment } from 'src/graphql'
import { formatLocation } from 'src/helpers'
import { Memoized } from 'src/hooks/dependencies'

const SelectMySponsor = (props: {
  onSelectedSponsor: Memoized<(sponsorId?: string) => void>
  onHasNoPossibleSponsors: Memoized<() => void>
}) => {
  const { onSelectedSponsor, onHasNoPossibleSponsors } = props
  const [selectedSponsor, setSelectedSponsor] = useState<SponsorFragment>()
  const [sponsors] = useQueries(getPossibleSponsors())

  useEffect(() => {
    sponsors.length === 0 && onHasNoPossibleSponsors()
    sponsors.length === 1 && onSelectedSponsor(sponsors[0].id)
  }, [sponsors, onHasNoPossibleSponsors, onSelectedSponsor])

  return (
    <Flex width="100%" flexDirection="column" justifyContent="space-between">
      <Div>
        <Text
          type="body"
          weight={'semiBold'}
          color="primaryHeading"
          alignment={'left'}
        >
          One Last Thing...
        </Text>
        <Spacer orientation="horizontal" space="x3" />
        <Text type="caption" outset={{ horizontal: 'auto' }}>
          We believe in celebrating the people who invite others to use
          SendOutCards. Choose the person from the list below so we can
          congratulate them!
        </Text>
      </Div>
      <Spacer space="x2" />
      <List orientation="vertical" alignment="center" overflow="auto">
        {sponsors.map(sponsor => {
          return (
            <ListItem key={sponsor.id} orientation="vertical" inset="x0">
              <SelectableCard
                isActive={selectedSponsor?.id === sponsor.id}
                onClick={() => {
                  selectedSponsor !== sponsor
                    ? setSelectedSponsor(sponsor)
                    : setSelectedSponsor(undefined)
                }}
              >
                <UserCard
                  profileImage={sponsor.storefront?.mugshot?.url}
                  firstName={sponsor.firstName}
                  lastName={sponsor.lastName}
                  caption={formatLocation(
                    sponsor.shippingAddress?.city,
                    sponsor.shippingAddress?.state,
                  )}
                  size="small"
                  active={selectedSponsor?.id === sponsor.id}
                />
              </SelectableCard>
            </ListItem>
          )
        })}
      </List>
      <Spacer space="x4" />
      <Flex flexDirection="column" alignItems="center">
        <Div>
          <Button
            title={
              selectedSponsor
                ? `Select ${selectedSponsor.firstName}`
                : `Select a Sponsor`
            }
            onClick={() => onSelectedSponsor(selectedSponsor?.id)}
            disabled={!selectedSponsor}
            fullWidth={false}
          />
        </Div>
        <Spacer space="x2" />
        <Anchor size="small" onClick={() => onSelectedSponsor()}>
          Choose for me
        </Anchor>
      </Flex>
    </Flex>
  )
}

export default SelectMySponsor
